import backgroundImagesJSON from './backgroundImagesFixture.json'

type BackgroundImagesCategoriesType = {
  [key: string]: {
    img1: string
    img1Alt: string
    img2: string
    img2Alt: string
  }
}

// We don't like to hardcode these images, so in pod encanto we created a ticket to address this
// https://masterclass-dev.atlassian.net/browse/PEN-2882a

export const BACKGROUND_IMAGES_CATEGORIES =
  backgroundImagesJSON as BackgroundImagesCategoriesType
